import dynamic from "next/dynamic";

const LocationSelectorNoSSR = dynamic(() => import("./NewLocationSelector"), {
  ssr: false,
});

export default LocationSelectorNoSSR;
